import { useTranslation } from "react-i18next";

const NativeSelect = ({ value, ...props }) => {
  const { t } = useTranslation();
  
  return (
    <div className="relative">
      <div className="bg-[white] flex items-center text-[hsl(0,_0%,_80%)] right-[0.1rem] w-[4rem] h-[3.5rem] top-[50%] absolute rounded-[0.4rem] z-[10] justify-center" style={{ transform: "translateY(-50%)" }}>
        <div className="self-[stretch] bg-[hsl(0,_0%,_80%)] w-[0.01rem] mr-[0.7rem]" />
        <svg fill="hsl(0, 0%, 80%)" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="h-[20] w-[20]">
          <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
        </svg>
      </div>
      <select
        className="h-[3.8rem] w-full appearance-none rounded-[0.4rem] border border-[rgba(197,214,222,0.7)] bg-white indent-[1rem] text-[hsl(0,0%,50%)] shadow-[0_2px_8px_#999] focus-visible:outline-none focus-visible:shadow-[0_0_0_0.3rem_rgb(0_168_255_/_25%)] active:shadow-[0_0_0_0.3rem_rgb(0_168_255_/_25%)]"
        value={
          value && props.getOptionValue
            ? props?.getOptionValue(value)
            : undefined
        }
        {...props}
      >
        <option defaultChecked>{t("select")}</option>
        {props?.options?.map((option, i) => (
          <option key={i} value={
              (props?.getOptionValue && props?.getOptionValue(option)) ||
              option.value
            }>
            {props?.getOptionLabel
              ? props?.getOptionLabel(option)
              : option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default NativeSelect;
